import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'
import { Link } from 'react-router'

import * as styles from './styles'

const FAEventCardHeader = ({ event }) => (
  <Card.Content>
    <Link to={`/familyAlbum/${event.id}`}>
      <Card.Header as="h3" style={styles.link}>
        {event.name}
      </Card.Header>
    </Link>
  </Card.Content>
)

FAEventCardHeader.propTypes = {
  event: PropTypes.object.isRequired,
}

export default FAEventCardHeader
